import { render, staticRenderFns } from "./AvailabilityConfigCard.vue?vue&type=template&id=15926094&"
import script from "./AvailabilityConfigCard.vue?vue&type=script&lang=js&"
export * from "./AvailabilityConfigCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports